/** Stagger Children upwards */
export const animateStaggerIn = {
  initial: { y: 20, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: { staggerChildren: 0.04 }
  }
};
